module.exports = __webpack_public_path__ + "img/lowerabs.6e3b5683.svg";